import { render, staticRenderFns } from "./academic_question_management.vue?vue&type=template&id=5d4dfcee&scoped=true&"
import script from "./academic_question_management.vue?vue&type=script&lang=js&"
export * from "./academic_question_management.vue?vue&type=script&lang=js&"
import style0 from "./academic_question_management.vue?vue&type=style&index=0&id=5d4dfcee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4dfcee",
  null
  
)

export default component.exports